module.exports = __webpack_public_path__ + "img/ganxi04.7f680988.png";